import React from 'react'
import { Box } from '@material-ui/core'
import { toFarsiDigits } from '../../assets/utils'

/** شمارهٔ صفحه‌ها: اعدادِ نزدیک به صفحهٔ جاری + «…» برای وسط‌ها */
export const pageItems = (cur, total) => {
    const out = []
    if (total <= 7) {
        for (let i = 1; i <= total; i++) out.push(i)
        return out
    }
    out.push(1)
    if (cur > 3) out.push('...')
    for (let i = Math.max(2, cur - 1); i <= Math.min(total - 1, cur + 1); i++) out.push(i)
    if (cur < total - 2) out.push('...')
    out.push(total)
    return out
}

const chip = (on) => ({
    minWidth: 30, height: 30, borderRadius: 8, cursor: 'pointer', userSelect: 'none',
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 13, fontWeight: 700, padding: '0 8px',
    background: on ? '#1a237e' : '#fff',
    color: on ? '#fff' : '#3949ab',
    border: '1px solid ' + (on ? '#1a237e' : '#c5cae9'),
})

const arrow = (off) => ({
    minWidth: 32, height: 30, borderRadius: 8,
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 20, lineHeight: 1, paddingBottom: 4,
    background: '#eef1ff', color: '#1a237e', border: '1px solid #c5cae9',
    cursor: off ? 'default' : 'pointer', opacity: off ? 0.35 : 1,
    pointerEvents: off ? 'none' : 'auto', userSelect: 'none',
})

/**
 * صفحه‌بندیِ یکسانِ سامانه: ‹ ۱ ۲ … ۹ ›
 * props: page (۱-پایه) · pages (تعداد کل) · onChange(page) · extra (اختیاری)
 */
const Pagination = ({ page = 1, pages = 1, onChange, extra, style }) => {
    if (!pages || pages < 2) return extra ? <Box style={style}>{extra}</Box> : null
    const go = (p) => { if (p >= 1 && p <= pages && p !== page && onChange) onChange(p) }
    return (
        <Box display="flex" justifyContent="center" alignItems="center" flexWrap="wrap"
            style={{ gap: 6, marginTop: 14, ...(style || {}) }}>
            <span style={arrow(page <= 1)} onClick={() => go(page - 1)} title="صفحهٔ قبلی">‹</span>
            {pageItems(page, pages).map((it, i) => (
                it === '...'
                    ? <span key={'e' + i} style={{ fontSize: 14, color: '#9aa1b9', padding: '0 2px' }}>…</span>
                    : (
                        <span key={it} style={chip(page === it)} onClick={() => go(it)}>
                            {toFarsiDigits(it)}
                        </span>
                    )
            ))}
            <span style={arrow(page >= pages)} onClick={() => go(page + 1)} title="صفحهٔ بعدی">›</span>
            {extra ? <Box style={{ marginRight: 10 }}>{extra}</Box> : null}
        </Box>
    )
}

export default Pagination
